// import { motion } from "framer-motion";
// import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet-async";
import PackagesSection from "@components/PackagesSection";
import HeroSectionUno from "@components/HeroSectionUno";
import WhySteerSmart from "@components/WhySteerSmart";
import ServicesSection from "@components/ServicesSection";
// import PropTypes from "prop-types";
import AboutSection from "@components/AboutSection";
import GoogleReviews from "@components/GoogleReviews";
// import ImportantInfo from "@components/ImportantInfo";
// import HeroCards from "../components/HeroCards";
// import CompanyNumbers from "../components/CompanyNumbers";
import Blogs from "./Blogs";
import SectionHeader from "@components/SectionHeader";
import Button from "@components/Button";

function Home() {
	return (
		<div className="flex flex-col gap-12 md:gap-32">
			<Helmet>
				<title>
					Steer Smart Driving School Canberra | Automatic & Manual Driving
					Lessons
				</title>
				<meta
					name="description"
					content="Learn to drive with confidence at Steer Smart Driving School Canberra. Manual and automatic driving lessons in Canberra with professional driving instructors."
				/>
				<link rel="canonical" href="https://steersmartdriving.com.au/" />
			</Helmet>

			{/* Hero Section */}
			<HeroSectionUno />

			{/* Hero Cards Section */}
			{/* 
				<HeroCards />
			 */}

			{/* Why Steer Smart Section */}
			<div className="flex flex-col justify-center items-center space-y-6 font-generalSans px-2 md:px-0">
				<SectionHeader
					title="Why Steer Smart?"
					subtitle="Signing up with Steer Smart means signing up for excellence. With patient and professional instructors focusing on your individual skills, we prioritise you and your safety along with your skill development."
				/>
				<WhySteerSmart />
			</div>

			{/* About Section */}
			<div className="flex flex-col gap-6 xl:lg:gap-12 font-generalSans">
				<SectionHeader
					title="Who Are We?"
					subtitle="Steer Smart Driving School Canberra is a leading driving school in the ACT and Queanbeyan. We are committed to providing high-quality driving lessons to students of all levels, from beginners to advanced drivers."
				/>
				<AboutSection />
			</div>

			{/* Services Section */}
			<div className="flex flex-col justify-center items-center space-y-6 font-generalSans px-2 md:px-0">
				<SectionHeader
					title="Our Services"
					subtitle="At Steer Smart Driving School Canberra, we offer a variety of services tailored to meet the needs of every driving student in the ACT and Queanbeyan."
				/>
				<ServicesSection isCarousel={true} />
				{/* <ServicesSection isCarousel desktopCards={3} gap={20} /> */}
			</div>

			{/* Packages Section */}
			<div
				id="packages-section"
				className="flex flex-col justify-center items-center gap-6 font-generalSans"
			>
				<SectionHeader
					title="Choose Your Lesson Plans"
					subtitle="Each of the packages listed below is available for both automatic and manual driving lessons. Choose the plan that suits your needs best."
				/>
				<PackagesSection number={3} />
				<Button
					buttonName="View All Packages"
					buttonStyle="primary"
					buttonLink="/packages"
				/>
			</div>

			{/* Blogs Section */}
			<div className="flex flex-col justify-center items-center gap-6 xl:lg:gap-16 font-generalSans">
				<SectionHeader
					title="From Our Blog"
					subtitle="Stay updated with the latest news, tips, and insights from Steer Smart Driving School. Our blog covers everything you need to know about driving lessons, road safety, and more."
				/>
				<Blogs numberOfPosts={4} showMetaTags={false} />
			</div>

			{/* Google Reviews Section */}
			<div className="flex flex-col justify-center items-center gap-6 xl:lg:gap-16 font-generalSans">
				<SectionHeader
					title="What Our Students Say"
					subtitle="Real reviews from real students"
				/>
				<GoogleReviews />
			</div>
		</div>
	);
}

export default Home;
